import { UnreadChatsStoreSlice } from './types';
import { reduxKey } from './constants';

export function getChatHasMessage(state: any): UnreadChatsStoreSlice {
  if (!state[reduxKey]) {
    return false;
  }
  return state[reduxKey];
}
